<template>
  <div class="w1200 newsBox">
    <div class="w1200" style="overflow: hidden;background-color: #F9F9F9">
      <div class="leftBox">
        <div class="bannerBox">
          <img :src="banner" alt="">
        </div>
        <div style="min-height: 70vh">
          <div class="pushu_nav">
            <div class="columnBoxInnner">
              <div class="columnBoxInnnerList">
                <div class="bookTitle">
                  谱牒文摘
                </div>
                <span v-for="(item,index) in bookType" :key="index" :class="currentPushu==index?'activenames':'names'" @click="gopushu(item,index)"><span class="span_name">{{ item.DICTIONARY_NAME }}</span><span v-if="index!=bookType.length-1" style="margin: 0 8px;">/</span></span>
                <div class="serchNew">
                  <span class="el-icon-search searchIcon" @click="goSearch" />
                  <input v-model="searchKey" type="text" placeholder="请输入关键字进行搜索">
                </div>
              </div>
            </div>
          </div>
          <div class="serchNew2">
            <span class="el-icon-search searchIcon" @click="goSearch" />
            <input v-model="searchKey" type="text" placeholder="请输入关键字进行搜索">
          </div>
          <div v-show="allbookData.length>0" class="showlist">
            <div v-for="(item,index) in allbookData" :key="index" class="lilist">
              <a class="phoneShow" :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank" />
              <!--<a :class="item.COVER?'imgBox':'imgBoxno'" :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank">-->
              <!--<img v-if="item.COVER" :src="item.COVER" alt="">-->
              <!--<img v-else :src="noIMG_list" alt="">-->
              <!--</a>-->
              <a class="titlename" :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank">
                <svg-icon icon-class="puwenIcon" />{{ item.SHOW_TITLE }}
              </a>
              <div class="msgMore">
                <div class="msguser">
                  <img :src="item.USER_PHOTO" alt="">
                </div>
                <span class="msgUsername">{{ item.USER_NAME }}</span>
                <span class="hot_time">{{ item.CREATE_DATE }}</span>
                <span class="el-icon-view viewNumber">   {{ item.SHOW_READ_SIZE|changenum }}</span>
                <span class="el-icon-star-on viewNumber"> {{ item.CONTENT_COLLECTION_NUMBER }}</span>
                <span class="viewNumber viewStar"><svg-icon icon-class="pinlun" />   {{ item.CONTENT_COLLECTION_NUMBER|changenum }}</span>
              </div>
              <div class="tip">
                {{ item.DICTIONARY_NAME }}
              </div>
              <div class="tip_right" style="display: none">
                <svg-icon icon-class="puwenIcon" />
              </div>
            </div>
          </div>
          <div v-show="allbookData.length<=0" style="text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
            暂无数据
          </div>
          <div class="addMore" @click="addMore">
            <span v-show="!loadAll" class="addMore_span">
              <span v-show="!isloading">加载更多</span>
              <span v-show="isloading" class="el-icon-loading" style="font-size: 16px" />
            </span>
            <span v-show="loadAll">已经到底了</span>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <Rightlist />
      </div>
    </div>
    <!--<div>2</div>-->
  </div>
</template>
<script>
import Rightlist from '@/components/commonRightList'
import { getClassz, getDataArticleList } from '@/api/api.js'
export default {
  components: { Rightlist },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '谱牒文摘-谱文品_谱文范文_谱文_百家姓谱文_各姓氏谱文-彭祖世家网',
      mateDesc: '彭祖世家网-谱牒文摘,电子谱文制作,谱文制作,谱文范本,谱文范文,智能谱文编写,家谱家书,谱文谱书,家族谱书等海量资源应有尽有',
      keys: '谱文模板,谱文封面,祭谱文,谱文样本,白话谱文,彭祖,彭城,彭氏,彭姓,彭氏家谱,彭氏宗谱,彭氏族谱,彭祖世家,彭氏修谱,门户网站'
    }
  },
  data() {
    return {
      isloading: false,
      searchKey: '',
      bookData: [],
      currerntPage: 1,
      currentType: '',
      loadAll: false,
      bookType: [{ DICTIONARY_ID: '', DICTIONARY_NAME: '全部' }],
      currentPushu: 0,
      pushu: require('@/static/puwen.png'),
      banner: require('@/static/puwen_banner.png'),
      noIMG: require('@/static/usuerDefault.png'),
      noIMG_list: require('@/static/puwenDefaultImg.png'),
      keys: '',
      logo: require('@/static/search_logo_peng.png'),
      currentIndex: 0,
      islogin: false,
      username: '',
      userData: {},
      arrs: [{ 'name': '账号设置' }, { 'name': '我的收藏' }, { 'name': '我的评论' }, { 'name': '我的消息' }, { 'name': '退出登录' }],
      banner_foot: require('@/static/banner_foot.png')
    }
  },
  computed: {
    allbookData() {
      if (this.$store.state.puwenList) {
        return this.$store.state.puwenList
      } else {
        return []
      }
    }
  },
  asyncData({ store, route }) {
    var obj = {
      page: 1,
      limit: 21
    }
    return store.dispatch('getDataArticleList', obj)
  },
  mounted() {
    // //回车搜索事件
    const that = this
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which
      if (keycode == 13) {
        that.goSearch()
        return false
      }
    }
    this.initType()
    this.fn()
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    gonav: function(index) {
      this.currentIndex = index
    },
    // /查询字典
    initType() {
      getClassz({ classCode: 'articleType' }).then(res => {
        this.bookType = this.bookType.concat(res.data)
        // console.log(res.data)
        for (let i = 0; i < this.bookType.length; i++) {
          if (this.bookType[i].DICTIONARY_ID == this.$route.query.classz) {
            this.currentPushu = i
          }
        }
      })
    },
    gopushu(names, index) {
      this.loadAll = false
      this.currerntPage = 1
      this.currentType = names.DICTIONARY_ID
      getDataArticleList({ str: this.searchKey, page: 1, limit: 12, type: names.DICTIONARY_ID, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        this.bookData = res.data.listMapData
        this.$store.commit('setDataArticleList', res.data.listMapData)
        if (res.data.count <= 12) {
          this.loadAll = true
        }
      })
      this.currentPushu = index
      if (this.$route.query.classz) {
        this.$router.replace('/booktextList')
      }
    },
    addMore() {
      this.isloading = true
      this.bookData = this.$store.state.puwenList
      this.currerntPage++
      getDataArticleList({ str: this.searchKey, page: this.currerntPage, limit: 12, type: this.currentType, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        this.bookData = this.bookData.concat(res.data.listMapData)
        this.$store.commit('setDataArticleList', this.bookData)
        setTimeout(() => {
          this.isloading = false
        }, 300)
        if (res.data.page <= this.currerntPage) {
          this.loadAll = true
        }
      })
    },
    goDetail(sourceId, type) {
      const { href } = this.$router.resolve({
        url: '/sourceView',
        name: 'sourceView',
        query: {
          sourceId,
          type
        }
      })
      window.open(href, '_blank')
    },
    goSearch: function() {
      this.bookData = this.$store.state.bookList
      this.currerntPage = 1
      getDataArticleList({ str: this.searchKey, page: this.currerntPage, limit: 12, type: this.currentType, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        this.bookData = this.bookData.concat(res.data.listMapData)
        this.$store.commit('setDataArticleList', this.bookData)
        if (res.data.page <= this.currerntPage) {
          this.loadAll = true
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .columnBoxInnnerList{
    text-align: left;
  }
  .bookTitle{
    display: inline-block;
    height: 20px;
    line-height: 20px;
    border-left: 2px solid #ed4040;
    padding-left: 10px;
    font-size: 18px;
    margin-left: 20px;
    font-weight: 600;
    margin-right: 20px;
  }

  .serchNew{
    vertical-align: top;
    height: 38px;
    width: 390px;
    border: 1px solid #E3003A;
    display: inline-block;
    position: relative;
    margin-bottom: 20px;
    float: right;
    margin-right: 20px;
    margin-top: 11px;
    .searchIcon{
      cursor: pointer;
      display: inline-block;
      position: absolute;
      top: 0;
      left: 330px;
      height: 38px;
      width: 65px;
      text-align: center;
      line-height: 38px;
      color: #E3003A;
      vertical-align: top;
      font-size: 20px;
    }
    input{
      height: 38px;
      width: 330px;
      position: absolute;
      left: 0;
      top: 0;
      text-indent: 8px;
    }
    .searchBtn{
      display: inline-block;
      position: absolute;
      right: 0;
      top: -1px;
      width: 125px;
      height: 39px;
      text-align: center;
      line-height: 38px;
      background-color: #E3003A;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .serchNew2{
    display: none;
  }

  .phoneShow{
    display: block;
    width: 100%;
    height: 100%;
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
  }
    ///列表样式
 .pushu_nav{
        overflow: hidden;
        text-align: center;
        background-color: #fff;
        height: 60px;
        line-height: 60px;
       margin-top: 20px;
      margin-bottom: 20px;
        span{
            font-size: 15px;
            color: #333333;
        }
        .names{
            .span_name{
                cursor: pointer;
                color: #333333;
              font-weight: 600;
              font-size: 16px;
            }
        }
        .activenames{
            .span_name{
                cursor: pointer;
                color: #E3003A;
              font-weight: 600;
              font-size: 16px;
            }
        }
    }
    .showlist{
        width: 100%;
        /*overflow: hidden;*/
        font-size: 0;
        padding-bottom: 20px;
        .lilist{
          padding-top: 10px;
          padding-bottom: 20px;
          background-color: #fff;
            margin-top: 20px;
            position: relative;
            /*margin-top: 43px;*/
            display: inline-block;
            width: 100%;
            overflow: hidden;
            margin-right: 35px;
            transition: 0.3s;
            font-size: 0;
            border-left: 1px solid #f0f0f0;
            border-right: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            -moz-box-shadow:1px 1px 3px #f3f3f3;
            -webkit-box-shadow:1px 1px 3px #f3f3f3;
            box-shadow:1px 1px 3px #f3f3f3;
            &:hover{
                transform: translate(0,-3px);
            }
            .imgBox{
                display: inline-block;
                width: 268px;
                height: 175px;
                overflow: hidden;
                img{
                    width: 268px;
                    height: 175px;
                    cursor: pointer;
                }
            }
            .imgBoxno{
              display: inline-block;
              width: 268px;
              height: 175px;
              overflow: hidden;
              img{
                width: 268px;
                height: 175px;
                cursor: pointer;
              }
            }
            p{
              cursor: pointer;
              height: 20px;
              overflow: hidden;
              white-space:nowrap;
              text-overflow:ellipsis;
                color: #333333;
                margin-top: 5px;
                font-size: 15px;
                padding-left: 10px;
            }
            .tip{
                position: absolute;
                top: 7px;
                left: 9px;
                display: inline-block;
                width: 60px;
                background-color:rgba(0,0,0,.3);
                color: #ffffff;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                text-align: center;
                border-radius: 2px;
                cursor: pointer;
                display: none;
                &:hover{
                    color: #ed4040;
                }
            }
          .tip_right{
            position: absolute;
            top: 150px;
            right: -16px;
            display: inline-block;
            width: 60px;
            color: #333;
            height: 20px;
            line-height: 20px;
            text-align: center;
            svg{
              font-size: 20px;
            }
          }
        }
      .lilist:nth-child(3n){
        margin-right: 0;
      }
    }
    .addMore{
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      color: #999999;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 3px;
      cursor: pointer;
      display: inline-block;
      width: 100%;
      margin-top: 20px;
      transition: 0.5s;
      text-align: center;
      margin-bottom: 60px;
      .addMore_span{
        cursor: pointer;
      }
      &:hover{
        border: 1px solid #E3003A;
        color: #E3003A;
      }
    }
    .firstcolumn_tip{
      margin-top: 20px;
      height: 68px;
      border: 1px solid #f0f0f0;
      text-align: center;
      line-height: 68px;
      background-color: #fff;
      font-size: 24px;
      color: #353535;
      font-weight: 600;
        img{
            width:auto;
            height: 29px;
            margin-top: 20px;
        }
    }
    .leftBox{
        width: 880px;
        margin-right: 20px;
        margin-top: 20px;
        float: left;
        .bannerBox{
            width: 880px;
            height: 340px;
            font-size: 0;
            img{
                width:100%;
                height: 340px;
            }
        }
    }
    .rightBox{
        width: 300px;
        margin-top: 20px;
        float: right;
        overflow: hidden;
    }
    .newsBox {
        position: relative;
        width: 100%;
        background-color: #F9F9F9;
        .top {
            position: absolute;
            top: 0;
            width: 100%;
            height: 140px;
            top: -180px;
            z-index: 9;
            background-color: #fff;
            .navs {
                height: 40px;
                background-color: #7e6b5a;
                width: 100%;
                .w1200s {
                    width: 1200px;
                    height: 40px;
                    background-color: #7e6b5a;
                    margin: 0 auto;
                    position: relative;
                    .head-ul {
                        display: inline-block;
                        overflow: hidden;
                        height: 40px;
                        background-color: #7e6b5a;
                        li {
                            display: inline-block;
                            margin-top: 10px;
                            a {
                                padding: 5px 14px;
                                margin: 0 5px;
                                cursor: pointer;
                                color: #ffffff;
                            }
                        }
                    }
                    .right_box {
                        display: inline-block;
                        float: right;
                        .login_register {
                            border-radius: 5px;
                            float: right;
                            width: 88px;
                            height: 28px;
                            margin: 5px 20px;
                            line-height: 28px;
                            /*border: 1px solid #ed4040;*/
                            a {
                                display: inline-block;
                                width: 42px;
                                text-align: center;
                                height: 16px;
                                margin-top: 6px;
                                font-size: 12px;
                                line-height: 16px;
                                color: #ffffff;
                            }
                        }
                        .login_register a:nth-of-type(1) {
                            border-right: 1px solid #fff;
                        }
                        .userBox {
                            border-radius: 5px;
                            width: 90px;
                            height: 30px;
                            margin: 5px 20px;
                            line-height: 30px;
                            transition: 0.5s;
                            position: absolute;
                            z-index: 5;
                            right: 0;
                            top: 0;
                            overflow: hidden;
                            &:hover {
                                height: 240px;
                            }
                            .imgBox {
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                                display: inline-block;
                                background-color: #e6e6e6;
                                vertical-align: top;
                                cursor: pointer;
                                font-size: 0;
                                img {
                                    width: 30px;
                                    height: 30px;
                                    border-radius: 50%;
                                }
                            }
                            .usercontent {
                                width: 150px;
                                display: inline-block;
                                height: 30px;
                                font-size: 12px;
                                color: #ffffff;
                                /*overflow: hidden;*/
                                margin-left: 5px;
                                cursor: pointer;
                                position: absolute;
                                z-index: 6;
                            }
                            .list {
                                margin-top: 10px;
                                background-color: #fff;
                                li {
                                    text-align: center;
                                    height: 36px;
                                    line-height: 36px;
                                    font-size: 12px;
                                    cursor: pointer;
                                    &:hover {
                                        background-color: #ed4040;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .logoBox {
                width: 444px;
                height: 60px;
                font-size: 0;
                display: inline-block;
                cursor: pointer;
                margin-top: 40px;
                vertical-align: top;
                img {
                    width: 444px;
                    height: 60px;
                }
            }
            .searchbox {
                display: inline-block;
                overflow: hidden;
                float: right;
                margin-top: 45px;
                span {
                    display: inline-block;
                    height: 38px;
                    width: 98px;
                    border: 1px solid #7e6b5a;
                    vertical-align: top;
                    text-align: center;
                    line-height: 40px;
                }
                .keys_input {
                    height: 38px;
                    width: 313px;
                    border-top: 1px solid #7e6b5a;
                    border-bottom: 1px solid #7e6b5a;
                    border-left: 1px solid #7e6b5a;
                    padding-left: 5px;
                    vertical-align: top;
                }
                .btn {
                    display: inline-block;
                    background-color: #7e6b5a;
                    color: #ffffff;
                    line-height: 40px;
                    height: 40px;
                    text-align: center;
                    width: 101px;
                    cursor: pointer;
                }
            }
            .bannerbox {
                width: 100%;
                height: 500px;
                font-size: 0;
                margin-top: 40px;
                position: relative;
                background-position: center center;
                background-size: auto 100%;
                img {
                    width: 100%;
                    height: 500px;
                }
                .numberCount {
                    position: absolute;
                    top: 332px;
                    width: 100%;
                    text-align: center;
                    color: #bb955b;
                    font-family: '微软宋体';
                }
            }
        }
    }
    .showlist .lilist .titlename{
      color: #333333;
      font-size: 15px;
      font-weight: 600;
      display: inline-block;
      padding-top: 8px;
      padding-left: 20px;
      padding-right: 20px;
      height: 70px;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      svg{
        font-size: 20px;
        color:#E3003A;
        margin-right: 10px;
      }
    }
  .hot_time{
    display: inline-block;
    width: 150px;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    color: #b2b2b2;
    padding-left: 10px;
    margin-right: 320px;
  }
    .viewNumber{
      display: inline-block;
      height: 25px;
      line-height: 25px;
      width: 70px;
      font-size: 14px;
      color: #b2b2b2;
      text-align: right;
    }
  .msgMore{
    white-space: nowrap;
    .msguser{
      display: inline-block;
      width: 25px;
      height: 25px;
      vertical-align: middle;
      padding-left: 20px;
      img{
        width: 25px;
        height: 25px;
        border-radius: 50%;
      }
    }
  }
  .msgUsername{
    display: inline-block;
    font-size: 14px;
    margin-left: 5px;
    margin-right: 10px;
    width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .serchNew2{
      vertical-align: top;
      height: 33px;
      width: 80%;
      border: 1px solid #E3003A;
      display: inline-block;
      position: relative;
      margin-bottom: 20px;
      margin-left: 10%;
      margin-top: 11px;
      border-radius: 23px;
      .searchIcon{
        cursor: pointer;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 250px;
        height: 35px;
        width: 15%;
        text-align: center;
        line-height: 35px;
        color: #E3003A;
        vertical-align: top;
        font-size: 20px;
      }
      input{
        height: 35px;
        width: 75%;
        position: absolute;
        left: 15px;
        top: 0;
      }
    }
    .bookTitle{
      margin-left: 0;
    }
    .serchNew{
      width: 100%;
      display: none;
    }

    .showlist .lilist .tip_right{
      display: none;
    }
    .showlist .lilist .titlename{
      padding: 0!important;
      height: 40px!important;
    }
    .viewNumber{
      height: auto;
      text-align: right;
      width: 70px;
      font-size: 12px;
    }
    .hot_time{
      padding-left: 0;
      margin-right: 0;
      margin-left: 5px;
      width: 120px;
      font-size: 12px;
    }
    .msgMore{
      width: 100%;
      overflow: hidden;
      display: inline-block;
      .msguser{
        padding-left: 0;
        width: 20px;
        height: 20px;
        img{
          width: 20px;
          height: 20px;
        }
      }
      .msgUsername{
        font-size: 12px;
        margin-right: 0;
        margin-left: 9px;
      }
    }
    .showlist{
      padding: 0 20px;
      padding-bottom: 20px;
      width: auto;
      background-color: #fff;
    }
    .readSize{
      margin-left: 0px;
      text-align: right;
      width: 70px;
      margin-top: 10px;
    }
    .collectionSize{
      text-align: left;
      width: 70px;
      margin-top: 10px;
    }
    .speckSize{
      text-align: left;
      width: 70px;
      margin-top: 10px;
    }
    .top{
      display: none;
    }
    .leftBox{
      width: 100%;
      margin-top: 0;
      .bannerBox{
        width: 100%;
        height: auto;
        img{
          width: 100%;
          height: auto;
        }
      }
      .firstcolumn_tip{
        width: 100%;
        height: auto;
        background-color: #fff;
        text-align: center;
        img{
          width: 90%;
          height: auto;
        }
      }
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
      .pushu_nav{
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        span{
          float: none;
          margin: 0 auto 20px;
        }
      }
      .lilist{
        width: 100%;
        margin-left: 0;
        border: none;
        border-bottom: 1px solid #eee;
        box-shadow:none;
        padding-bottom: 20px;
        padding-top: 0;
        .tip{
          display: none;
        }
        .right_div{
          width: 70%!important;
          float: left;
          height: 130px;
          overflow: hidden;
          margin: 0;
          .puxi_foot{
            margin-top: 0;
          }
        }

        .imgBox{
          width: 30%;
          float: right;
          height: 130px;
          overflow: hidden;
          img{
            height: 130px;
            width: auto;
          }
        }
        .imgBoxno{
          display: none;
        }
      }
    }
    .rightBox{
      display: none;
    }
  }
</style>

